import Keycloak, { KeycloakConfig, KeycloakInitOptions } from "keycloak-js";
import { AUTH_CLIENT_ID, AUTH_REALM, AUTH_URL, IS_DEVELOPMENT } from "utils/constants";

/**
 * See https://www.keycloak.org/docs/16.1/securing_apps/index.html#_javascript_adapter
 */

export const keycloakOptions: KeycloakConfig = {
  clientId: AUTH_CLIENT_ID ?? "",
  realm: AUTH_REALM ?? "",
  url: AUTH_URL ?? "",
};

// Determines the range of time around a token's expiry that will cause keycloak to refresh the token.
export const MINIMUM_UPDATE_TOKEN_VALIDITY_MS = 5;

export const keycloak: Keycloak = new Keycloak(keycloakOptions);

export const keycloakInitOptions: KeycloakInitOptions = {
  flow: "standard",
  pkceMethod: "S256",
  onLoad: "check-sso",
  enableLogging: IS_DEVELOPMENT,
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
};

export const baseEmailResetUrl = new URL(
  `/realms/${AUTH_REALM}/protocol/openid-connect/auth`,
  `${AUTH_URL}`,
);

export default keycloak;
